import { CatalogPayer, EnterCatalog } from './worker-automation.types';

/**
 * Payer-name lookup, kept in its own leaf module on purpose.
 *
 * It used to live in `worker-automation-catalog.ts`, which imports `ui/data-table` for its
 * picker filters. That made every consumer of this six-line pure function — including the
 * scope registry — transitively depend on React UI, and put the registry out of reach of the
 * DOM-free `jest.services.config.js` suite. Nothing here may import from `ui/`.
 */
export function getCatalogPayerName(
    catalog: EnterCatalog | null | undefined,
    payerId: string,
    payerById?: Record<string, CatalogPayer>,
): string | undefined {
    return payerById?.[payerId]?.name ?? catalog?.payers.find(payer => payer.payerId === payerId)?.name;
}
